/**
 * Gera o ícone PWA via canvas e injeta dinamicamente no manifest e apple-touch-icon.
 * Fundo: degradê cinza claro. Logo: original centralizada.
 */

const LOGO_URL =
  "https://static.readdy.ai/image/1b0e966215e432d351b2e9c11ca0b10e/154dcc8a65fed03ee4761cc080c3eddf.png";

function roundedRect(
  ctx: CanvasRenderingContext2D,
  size: number,
  radius: number
) {
  ctx.beginPath();
  ctx.moveTo(radius, 0);
  ctx.lineTo(size - radius, 0);
  ctx.quadraticCurveTo(size, 0, size, radius);
  ctx.lineTo(size, size - radius);
  ctx.quadraticCurveTo(size, size, size - radius, size);
  ctx.lineTo(radius, size);
  ctx.quadraticCurveTo(0, size, 0, size - radius);
  ctx.lineTo(0, radius);
  ctx.quadraticCurveTo(0, 0, radius, 0);
  ctx.closePath();
}

function generateIcon(size: number): Promise<string> {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d")!;
    const radius = size * 0.22;

    // Clip arredondado
    roundedRect(ctx, size, radius);
    ctx.save();
    ctx.clip();

    // Fundo degradê cinza claro
    const grad = ctx.createLinearGradient(0, 0, size, size);
    grad.addColorStop(0, "#f7f7f7");
    grad.addColorStop(0.5, "#eeeeee");
    grad.addColorStop(1, "#e2e2e2");
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, size, size);

    // Brilho sutil no topo
    const shine = ctx.createRadialGradient(
      size * 0.5,
      size * 0.05,
      0,
      size * 0.5,
      size * 0.5,
      size * 0.75
    );
    shine.addColorStop(0, "rgba(255,255,255,0.5)");
    shine.addColorStop(1, "rgba(255,255,255,0)");
    ctx.fillStyle = shine;
    ctx.fillRect(0, 0, size, size);

    ctx.restore();

    // Logo centralizada
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const pad = size * 0.17;
      const logoSize = size - pad * 2;
      ctx.drawImage(img, pad, pad, logoSize, logoSize);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve("");
    img.src = LOGO_URL;
  });
}

export async function injectPwaIcons() {
  try {
    const [icon192, icon512] = await Promise.all([
      generateIcon(192),
      generateIcon(512),
    ]);

    if (!icon192 || !icon512) return;

    // Apple touch icon
    let appleLink = document.querySelector<HTMLLinkElement>(
      'link[rel="apple-touch-icon"]'
    );
    if (!appleLink) {
      appleLink = document.createElement("link");
      appleLink.rel = "apple-touch-icon";
      document.head.appendChild(appleLink);
    }
    appleLink.href = icon512;

    // Favicon
    let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.type = "image/png";
    favicon.href = icon192;

    // Manifest dinâmico
    const manifestData = {
      name: "EntreNós",
      short_name: "EntreNós",
      description:
        "Plataforma de conexão para casais com missões, experiências e IA personalizada.",
      start_url: "/",
      display: "standalone",
      background_color: "#f0f0f0",
      theme_color: "#e11d48",
      orientation: "portrait",
      categories: ["lifestyle", "social"],
      lang: "pt-BR",
      scope: "/",
      icons: [
        {
          src: icon192,
          sizes: "192x192",
          type: "image/png",
          purpose: "any",
        },
        {
          src: icon512,
          sizes: "512x512",
          type: "image/png",
          purpose: "any maskable",
        },
      ],
    };

    const blob = new Blob([JSON.stringify(manifestData)], {
      type: "application/json",
    });
    const manifestUrl = URL.createObjectURL(blob);

    let manifestLink = document.querySelector<HTMLLinkElement>(
      'link[rel="manifest"]'
    );
    if (!manifestLink) {
      manifestLink = document.createElement("link");
      manifestLink.rel = "manifest";
      document.head.appendChild(manifestLink);
    }
    manifestLink.href = manifestUrl;
  } catch {
    // silencioso
  }
}
